export const RATING_B = "2";
export const RATING_D = "4";
export const RATING_H = "8";

export const TABLE_RATING_VALUES = [
    RATING_B,
    RATING_D,
    RATING_H,
]

export const TABLE_RATING_BY_HEALTH_OPTION = {
    5: undefined,
    4: undefined,
    3: undefined,
    2: undefined,
    1: RATING_D,
}
